import React, { useRef } from "react";
import { useMount } from "react-use";

import { useIncode } from "./IncodeContext";

export const TutorialSelfie = () => {
  const containerRef = useRef(null);
  const { incode, navigateTo, track, token } = useIncode();

  useMount(() => {
    track("tutorial_selfie_viewed");
    incode.renderSelfieTutorial(containerRef.current, {
      token: { token },
      onSuccess: () => navigateTo("selfie"),
      noWait: true,
    });
  });

  return <div ref={containerRef}></div>;
};
